module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Route-9c5c6ddadacc1a7584bde553e91a8c9d.svg";